import { BaseWidget, WidgetResource, WidgetType } from "./base";

export interface TileGridWidget extends BaseWidget {
	type: WidgetType.TileGridWidget;
	heading: string;
	showTitle: boolean;
	sections: TileGridWidgetSection[];
	titleImage?: string; //uses the heading as alt text
	backgroundColor?: string //will eventually allow for images, but for now just hex codes.
}

export enum TileGridWidgetSectionType {
	Primary,
	Quarters,
	Thirds,
	Halves,
	Full,
	Fifths,
	Sixths,
}

export interface TileGridWidgetSection {
	type: TileGridWidgetSectionType;
	tiles: TileGridWidgetTile[];
}

export enum TileGridWidgetTileType {
	Invalid,
	Image,
	Banner,
	Split,
}

export enum TileGridWidgetTileShape {
	Half,
	Quarter,
	Third,
	Full,
	Fifth,
	Sixth,
}

export interface BaseTileGridWidgetTile {
	shape: TileGridWidgetTileShape;
}

export interface TileGridWidgetInvalidTile extends BaseTileGridWidgetTile {
	type: TileGridWidgetTileType.Invalid;
	json: string;
}

export interface TileGridWidgetImageTile extends BaseTileGridWidgetTile {
	type: TileGridWidgetTileType.Image;
	imageUrl: string;
	imageUrlWebP: string;
	imageUrlAvif: string;
	linkUrl: string;
	altText: string;
	dimensions: TileGridTileDimensions;
}

export interface TileGridWidgetSplitTile extends BaseTileGridWidgetTile {
	type: TileGridWidgetTileType.Split;
	imageTiles: TileGridWidgetImageTile[];
}
export interface TileGridWidgetBannerTile extends BaseTileGridWidgetTile {
	type: TileGridWidgetTileType.Banner;
	linkUrl: string;
	altText: string;
	mobile: string;
	mobileWebP: string;
	mobileAvif: string;
	mobileDimensions: TileGridTileDimensions;
	tablet: string;
	tabletWebP: string;
	tabletAvif: string;
	tabletDimensions: TileGridTileDimensions;
	desktop: string;
	desktopWebP: string;
	desktopAvif: string;
	desktopDimensions: TileGridTileDimensions;
}

export type TileGridWidgetTile = TileGridWidgetInvalidTile | TileGridWidgetImageTile | TileGridWidgetBannerTile | TileGridWidgetSplitTile;

export type TileGridTileDimensions = {
	width: number;
	height: number;
}

export interface TileGridWidgetData {
	tilesPerRowBySectionType: Record<TileGridWidgetSectionType, number>;
	tileDimensionsByTileShape: Record<TileGridWidgetTileShape, TileGridTileDimensions>;
}

export type TileGridWidgetResource = WidgetResource<TileGridWidget, TileGridWidgetData>;